import { Link } from "react-router-dom";

const CONSULT_URL = "https://buy.stripe.com/test_3cI3cw76afo3dj8ekM2cg00";

export function SiteFooter({ submissionId }) {
  return (
    <div className="site-footer" data-testid="site-footer">
      <div className="footer-brand">
        Green Routes Consulting &middot;{" "}
        <a href={CONSULT_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-phone">(323) 630-7533 — Book a Call</a>
        {" "}&middot;{" "}
        <a href="mailto:Greenroutesconsulting@gmail.com" data-testid="footer-email">Greenroutesconsulting@gmail.com</a>
      </div>
      <div className="footer-links">
        <Link to="/terms" data-testid="footer-terms">Terms &amp; Conditions</Link>
        <Link to="/privacy" data-testid="footer-privacy">Privacy Policy</Link>
      </div>
      {submissionId && (
        <p className="text-xs mt-3" style={{ fontFamily: "'JetBrains Mono', monospace", color: "var(--text-tertiary)" }}>
          ID: {submissionId}
        </p>
      )}
    </div>
  );
}
